import type {
  CreateSubjectPricingRequest,
  PricingConfiguration,
  PricingResponse,
  SubjectsWithCurriculumLevelsResponse,
  UpdatePricingRequest,
} from "@/features/calendar/types/pricing";

import { axiosApiInstance } from "@/libs/axios.tsx";
import { API_ENDPOINTS, WORKSPACES_API_ENDPOINTS } from "@/constants/api.ts";

// Get all pricing configurations
export const getAllPricingConfigurations = async () => {
  return axiosApiInstance.get<PricingResponse>(API_ENDPOINTS.TUTOR.SCHEDULE.PRICING);
};

// Update default pricing
export const updateDefaultPricing = async (data: UpdatePricingRequest) => {
  return axiosApiInstance.post<{
    message?: string;
    data: PricingConfiguration;
  }>(API_ENDPOINTS.TUTOR.SCHEDULE.PRICING, data);
};

// Create subject-specific pricing
export const createSubjectPricing = async (data: CreateSubjectPricingRequest) => {
  return axiosApiInstance.post<{ data: PricingConfiguration }>(
    `${API_ENDPOINTS.TUTOR.SCHEDULE.PRICING}/subjects`,
    {
      tutor_profile_subject_id: data.tutor_profile_subject_id,
      curriculum_level_id: data.curriculum_level_id,
      amount: data.amount,
      currency: data.currency,
    },
  );
};

// Delete pricing configuration
export const deletePricingConfiguration = async (id: string) => {
  return axiosApiInstance.delete<{ message: string }>(
    `${API_ENDPOINTS.TUTOR.SCHEDULE.PRICING}/${id}`,
  );
};

// Get subjects with curriculum levels
export const getSubjectsWithCurriculumLevels = async () => {
  return axiosApiInstance.get<SubjectsWithCurriculumLevelsResponse>(
    `${API_ENDPOINTS.TUTOR.SCHEDULE.PRICING}/data/subjects`,
  );
};
export const calculateLessonPrice = async (
  workspaceId: string,
  data: {
    schedule_calendar_slot_id: string;
    subject_id: string;
    curriculum_level_id: string;
  },
) => {
  return axiosApiInstance.post<{
    data: {
      currency: string;
      currency_symbol: string;
      subtotal: number;
      subtotal_formatted: string;
      service_fee: number;
      service_fee_formatted: string;
      total: number;
      total_formatted: string;
      duration_minutes: number;
      hourly_rate: number;
      hourly_rate_formatted: string;
    };
  }>(`${WORKSPACES_API_ENDPOINTS(workspaceId).STUDENT.RESERVE_SLOT}/calculate-price`, data);
};
